import React, { useMemo } from "react";
import { HeaderGroup } from "react-table";
import { Select, SimpleGrid, Text } from "@chakra-ui/react";

interface Props {
  column: HeaderGroup;
}

const SelectFilter: React.FC<Props> = ({
  column: { filterValue, setFilter, preFilteredRows, id, render }
}: Props) => {
  const options = useMemo(() => {
    const options = new Set<any>();
    preFilteredRows.forEach(row => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <SimpleGrid>
      <Text>{render("Header")}</Text>
      <Select
        value={filterValue || ""}
        onChange={e => setFilter(e.target.value || undefined)}
        size="sm"
      >
        <option value="">All</option>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </SimpleGrid>
  );
};

export default SelectFilter;
